import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7f8f653c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "iframe"
};
const _hoisted_2 = {
  class: "iframe-container"
};
const _hoisted_3 = ["src"];
import { computed, onMounted, onBeforeUnmount, watch } from 'vue';
import { useStore } from 'vuex';
import router from '@remote/router';
import { useDeviceStore } from '@remote/store/device';
import { useRequestDelegate } from '@shared/composable/base';
import { KUAINIAO_ORIGIN } from '@shared/constants/URLs';
import PageHeader from '@remote/components/PageHeader.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'pluginIframe',
  setup(__props) {
    const store = useStore();
    const currentIframeUrl = computed(() => {
      return router.currentRoute.value.query.currentIframeUrl;
    });
    const currentIframeTitle = computed(() => {
      return router.currentRoute.value.query.currentIframeTitle;
    });
    const currentIframeShowClose = computed(() => {
      return router.currentRoute.value.query.currentIframeShowClose === '1';
    });
    const isFullScreen = computed(() => {
      return store.getters.isFullScreen;
    });
    const showHeader = computed(() => {
      return store.getters.showHeader;
    });
    const handleBack = () => {
      router.go(-1);
    };
    const handleClose = () => {
      router.replace({
        path: '/plugin',
        query: router.currentRoute.value.query
      });
    };
    const deviceStore = useDeviceStore();
    const isCurrentDeviceOnline = computed(() => {
      var _deviceStore$currentD;
      return ((_deviceStore$currentD = deviceStore.currentDeviceRef) === null || _deviceStore$currentD === void 0 ? void 0 : _deviceStore$currentD.runnerTaskRef.phase) === 'PHASE_TYPE_RUNNING';
    });
    let unwatchDeviceOffline = null;
    onMounted(async () => {
      document.title = currentIframeTitle.value || '更多';
      await deviceStore.untilDeviceReady();
      const {
        addListener,
        setIframeContentWindow,
        postDelegateReady,
        postDeviceOffline
      } = useRequestDelegate(deviceStore.currentDeviceRef.proxyFetch, {
        navigate: true
      });
      // 快鸟页面处理
      if (currentIframeUrl.value.startsWith(KUAINIAO_ORIGIN)) {
        const iframe = document.getElementById('plugin_loader');
        addListener();
        if (iframe) {
          iframe.onload = () => {
            if (iframe !== null && iframe !== void 0 && iframe.contentWindow) {
              setIframeContentWindow(iframe.contentWindow);
              postDelegateReady();
              console.log('DELEGATE_READY');
            }
          };
        }
        unwatchDeviceOffline = watch(isCurrentDeviceOnline, isOnline => {
          if (!isOnline) {
            postDeviceOffline();
          }
        });
      }
    });
    onBeforeUnmount(() => {
      const {
        removeListener
      } = useRequestDelegate(deviceStore.currentDeviceRef.proxyFetch, {
        navigate: true
      });
      removeListener();
      if (unwatchDeviceOffline && typeof unwatchDeviceOffline === 'function') {
        unwatchDeviceOffline();
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [showHeader.value ? (_openBlock(), _createBlock(PageHeader, {
        key: 0,
        title: currentIframeTitle.value,
        onBack: handleBack,
        onClose: handleClose,
        "is-close-show": currentIframeShowClose.value
      }, null, 8, ["title", "is-close-show"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_createElementVNode("iframe", {
        id: "plugin_loader",
        class: _normalizeClass([{
          'show-full': !currentIframeTitle.value && isFullScreen.value,
          'show-title-full': currentIframeTitle.value && isFullScreen.value,
          'show-title': currentIframeTitle.value && !isFullScreen.value
        }, "current-plugin-iframe"]),
        src: currentIframeUrl.value,
        frameborder: "0",
        name: "plugin_loader"
      }, null, 10, _hoisted_3)])]);
    };
  }
});